import { applyMiddleware, combineReducers, compose, createStore as _createStore, Reducer, StoreEnhancer } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IReduxStore, TReduxActions } from '../../types/redux';
import { buildersLocationsReducer, buildersProjectsReducer, filtersReducer, seoReducer } from '../../reducers/';

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers({
    buildersProjects: buildersProjectsReducer,
    buildersLocations: buildersLocationsReducer,
    filters: filtersReducer,
    seo: seoReducer,
  }) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context))) as unknown as StoreEnhancer;

  const createStore = (): IReduxStore => _createStore(reducers, initialState, storeEnchancers) as IReduxStore;

  return createStore();
}
